import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConnectingCableDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85921 38.4464C5.19537 34.7826 5.19537 28.8423 8.85921 25.1784L10.9445 23.0931C11.6707 22.3671 12.8481 22.3671 13.5743 23.0931L24.2124 33.7311C24.9385 34.4575 24.9385 35.6348 24.2124 36.3611L22.1271 38.4464C18.4633 42.1103 12.523 42.1103 8.85921 38.4464Z",
			stroke: "#8588D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.85011 38.4487L1.99792 45.3009",
			stroke: "#8588D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.141 8.16487C35.4772 4.50103 29.5369 4.50103 25.873 8.16487L23.7877 10.2501C23.0616 10.9763 23.0616 12.1538 23.7877 12.88L34.426 23.5181C35.152 24.2442 36.3294 24.2442 37.0557 23.5181L39.141 21.4328C42.8049 17.769 42.8049 11.8287 39.141 8.16487Z",
			stroke: "white",
			strokeOpacity: .16,
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M45.4729 0.770608C45.7658 0.47789 46.2406 0.477773 46.5334 0.770608C46.8259 1.06347 46.826 1.53836 46.5334 1.83115L40.178 8.18565C40.0161 7.99822 39.8491 7.8128 39.6711 7.63487C39.4925 7.45621 39.3066 7.28762 39.1184 7.1251L45.4729 0.770608Z",
			fill: "white",
			fillOpacity: .16
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4341 24.9489L19.5443 20.8386M22.3547 31.8695L26.465 27.7593",
			stroke: "#8588D8",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgConnectingCableDark;
